import { render, staticRenderFns } from "./dingTable.vue?vue&type=template&id=dce3efa8&scoped=true&"
import script from "./dingTable.vue?vue&type=script&lang=js&"
export * from "./dingTable.vue?vue&type=script&lang=js&"
import style0 from "./dingTable.vue?vue&type=style&index=0&id=dce3efa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce3efa8",
  null
  
)

export default component.exports